module.exports = __webpack_public_path__ + "static/img/wr.cc56caf2.webp";